var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-upload',{attrs:{"beforeUpload":_vm.beforeUpload,"show-upload-list":false,"custom-request":_vm._uploadFile,"disabled":_vm.loading}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }